export const IN_PAGE_STEP_DEPTH_KEY = '__welloStepDepth';

//* 경로가 안 바뀌는 단계 엔트리는 경로 기준 HistoryStore가 세지 못한다 — 대체 경로 대신 pop해야 이전 단계로 간다
export const hasInPageStepHistoryEntry = () =>
  typeof window !== 'undefined' &&
  Number(window.history.state?.[IN_PAGE_STEP_DEPTH_KEY]) > 0;
